import React, { useMemo } from 'react';

import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import sortServiceDockets from '../../../../common/utils/serviceDocket/sortServiceDockets';
import { useUserContext } from '../../../../common/utils/context';
import { ROLE_PERMISSIONS } from '../../../../common/constants';

import { Button, Separator } from '../../../components';
import Text from '../../../components/text/Text';

import ServiceRunBrief from '../ServiceRunBrief';

const ServiceRunServicingDetail = ({ servicerun, setIsServiceRunCashBagsDialogOpen, styles }) => {

	const navigation = useNavigation();
	const { hasPermission, tenantSettings } = useUserContext();
	const { serviceDockets } = servicerun;

	const _goToTicketSummary = () => navigation.push('TicketSummaryView', { id: servicerun.id });

	const openServiceRunEditor = () => {
		navigation.push('ServiceRunEditorView', {
			serviceRunId: servicerun.id,
			routeId: servicerun.route.id,
			serviceRunName: (servicerun.route && servicerun.route.name) ? servicerun.route.name : 'Routeless service run',
			seviceRunMachines: serviceDockets.map(docket => docket.machine.id),
			serviceRunDate: servicerun.planned,
		});
	};

	// Sort dockets by service time if completed, and by location if not
	const dockets = useMemo(() => [...serviceDockets].sort(sortServiceDockets), [serviceDockets]);

	const isCashCollectedFromAnyMachine = useMemo(() => serviceDockets.some(docket => docket.collectCash), [serviceDockets]);

	return (
		<>
			<Separator style={styles.separator} />
			<Text style={styles.headerText}>Servicing details</Text>
			<View style={styles.detailView}>
				<View style={styles.nthRow}>
					<Button
						label={`Change machines${tenantSettings.usesMarkets ? '/markets' : ''} (${dockets.length})`}
						style={styles.firstButton}
						disabled={!hasPermission(ROLE_PERMISSIONS.ADD_EDIT_SERVICE_RUNS)}
						onPress={openServiceRunEditor}
					/>
					<Button
						label="Ticket summary"
						style={styles.secondButton}
						onPress={_goToTicketSummary}
					/>
				</View>
				<View style={styles.nthRow}>
					<Button
						style={styles.firstButton}
						label={servicerun.isOneCashBag ? `Cash bag${servicerun.cashBag ? ` (${servicerun.cashBag})` : ''}` : 'Cash bags'}
						onPress={() => setIsServiceRunCashBagsDialogOpen(true)}
						disabled={isCashCollectedFromAnyMachine}
					/>
					{/* Outlined: Pick list summary is the page's one filled button. */}
					<ServiceRunBrief
						serviceRun={servicerun}
						style={styles.secondButton}
						secondary={false}
					/>
				</View>
			</View>
		</>
	);
};

export default ServiceRunServicingDetail;
